<template>
  <div class="body-center-content">
    <TranscriptionTranscribedText
      :transcription="transcription"
      :is-transcription-result-empty="isTranscriptionResultEmpty"
      @click:play-at="playAudio"
    />
  </div>
  <div class="body-center-bottom">
    <AudioPlayer
      ref="audioPlayer"
      :transcription="transcription"
      :transcription-exists="transcriptionExists"
      :transcription-in-progress="transcriptionInProgress"
      :audio-url="props.audioUrl"
      :audio-unavailable="props.audioUnavailable"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, DeepReadonly } from 'vue';
import { Transcription, ZoomPhoneResult } from '@/api/openapi';
import AudioPlayer from '@/components/organisms/va-app/transcription/AudioPlayer.vue';
import TranscriptionTranscribedText from '@/components/organisms/va-app/transcription/TranscriptionTranscribedText.vue';

type Props = {
  zoomPhoneResult: ZoomPhoneResult | null;
  transcription: DeepReadonly<Transcription> | undefined;
  transcriptionExists: boolean;
  isTranscriptionResultEmpty: boolean;
  transcriptionInProgress: boolean;
  audioUrl: string | undefined;
  audioUnavailable: boolean;
};

const props = defineProps<Props>();

const audioPlayer = ref<InstanceType<typeof AudioPlayer>>();

const playAudio = (time: number) => {
  audioPlayer.value?.playAudio(time);
};

// 親コンポーネントから直接playAudioを呼び出せるようにする
defineExpose({ playAudio });
</script>

<style lang="scss" scoped>
.body-center-content {
  flex: 1 1 auto;
  min-height: 0;
}

.body-center-bottom {
  flex: 0 0 auto;
}
</style>
